import React, { useEffect, useState } from 'react';

const As = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 800);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="full-screen-image">
            <nav className="as-navbar">
                <div
                    className="logo show"
                    onClick={() => {
                        window.location.href = "http://eplusdentistry.com/";
                    }}
                >
                    <img
                        src={`${process.env.PUBLIC_URL}/image/${
                            isMobile ? "mo/moHeader.png" : "pc/pcHeader.png"
                        }`}
                        alt="이플러스치과 로고"
                    />
                </div>
            </nav>
            <img
                className="responsive-image"
                src={`${process.env.PUBLIC_URL}/image/as/${isMobile ? "mo" : "pc"}.png`}
                alt="이플러스치과 비급여수가표"
            />
            <style jsx>{`
                .full-screen-image {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    /* 고정된 헤더 높이(22px 여백 + 이미지 높이 1920:138) 만큼 확보 */
                    padding-top: calc(22px + 7.1875vw);
                }
                .responsive-image {
                    display: block;
                    width: 100%;
                    max-width: 100%;
                    height: auto;
                    /* flex item의 기본 min-width:auto 때문에 이미지가 원본 폭 이하로
                       줄지 않아 오른쪽이 잘리는 것을 방지 */
                    min-width: 0;
                }
                .as-navbar {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    padding-top: 22px;
                    background-color: white;
                    z-index: 1000;
                }
                .as-navbar .logo {
                    cursor: pointer;
                }
                .as-navbar .logo img {
                    display: block;
                    width: 100vw;
                    max-width: 100%;
                    height: auto;
                }
                @media (max-width: 800px) {
                    /* 모바일 헤더 이미지 비율 800:138 */
                    .full-screen-image {
                        padding-top: calc(22px + 17.25vw);
                    }
                }
            `}</style>
        </div>
    );
};

export default As;
